import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "asin-image-container"
};
var _hoisted_2 = {
  key: 0,
  class: "badge-tag"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://m.media-amazon.com/images/G/28/NewApp/00_EN/CBadge_NY_Tips_English.gif",
  alt: ""
}, null, -1);
var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = {
  alt: ""
};
var _hoisted_6 = {
  class: "asin-content-container"
};
var _hoisted_7 = {
  class: "asin-title"
};
var _hoisted_8 = {
  class: "asin-price"
};
var _hoisted_9 = {
  class: "price"
};
var _hoisted_10 = {
  key: 0,
  class: "badge"
};
var _hoisted_11 = {
  class: "badge-line"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  key: 0,
  class: "badge-text"
};
var _hoisted_14 = ["src"];
import { inject } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import { isShowPIPLConfirmAlertView, imageCutEdgeAndSetSize } from '@/utils/common';
export default {
  __name: 'AsinItem',
  props: {
    asinBadge: {
      type: String
    },
    isShowBuyButton: {
      type: Boolean
    },
    asinItem: {
      type: Object,
      default: () => null
    }
  },
  emits: ['onClickBuyPop'],
  setup(__props, {
    emit
  }) {
    useLess('views/landingPage/asinShowcase/AsinItem.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var router = useRouter();
    var couponInfo = inject('couponInfo', null);
    var routeToDetailPage = item => {
      router.push({
        name: 'detailPage',
        params: {
          asinId: item.asin
        }
      });
    };
    var onClickBuyPop = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return isShowPIPLConfirmAlertView();
            case 2:
              if (!_context.sent) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              emit('onClickBuyPop', {
                merchantId: item.merchantId,
                selectedAsin: item.asin
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onClickBuyPop(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return (_ctx, _cache) => {
      var _props$asinItem$ourP, _unref$MERCHANT_BADGE, _unref$MERCHANT_BADGE2, _props$asinItem, _props$asinItem$deliv;
      var _directive_lazy = _resolveDirective("lazy");
      return __props.asinItem ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "asin-showcase-item",
        onClick: _cache[1] || (_cache[1] = $event => routeToDetailPage(__props.asinItem))
      }, [_createElementVNode("div", _hoisted_1, [__props.asinBadge ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(__props.asinItem.mainImage)]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(__props.asinItem.title), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$asinItem$ourP = __props.asinItem.ourPrice) === null || _props$asinItem$ourP === void 0 ? void 0 : _props$asinItem$ourP.amount), 1), _unref(couponInfo) ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_unref(t)('common.FULL_REDUCTION_COUPON', {
        amount: _unref(couponInfo).threshold,
        promotion: _unref(couponInfo).amount
      })), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        src: (_unref$MERCHANT_BADGE = _unref(constants).MERCHANT_BADGE_MAP) === null || _unref$MERCHANT_BADGE === void 0 ? void 0 : (_unref$MERCHANT_BADGE2 = _unref$MERCHANT_BADGE[__props.asinItem.merchantId]) === null || _unref$MERCHANT_BADGE2 === void 0 ? void 0 : _unref$MERCHANT_BADGE2.badgeURL,
        alt: ""
      }, null, 8, _hoisted_12), (_props$asinItem = __props.asinItem) !== null && _props$asinItem !== void 0 && (_props$asinItem$deliv = _props$asinItem.delivery) !== null && _props$asinItem$deliv !== void 0 && _props$asinItem$deliv.isGlobalStoreFreeShippingProgram ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('common.FREE_SHIPPING')), 1)) : _createCommentVNode("", true)]), __props.isShowBuyButton ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn-buy",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => onClickBuyPop(__props.asinItem), ["stop"]))
      }, [_createElementVNode("img", {
        src: `${_unref(constants).IMAGE_URL}assets/svg/detailTags/stroke.svg`,
        alt: ""
      }, null, 8, _hoisted_14)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true);
    };
  }
};